import axios from 'axios';

// export const REST_API = 'https://sp.demoapi.v2.hyperthings.in/api/v1/';
export const REST_API = 'https://hts.mobile.hyperthings.in/api/v1/';

// axios implementation
export const fetcher = axios.create({
  baseURL: REST_API,
  timeout: 13000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

const token =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ijk5Yzc4MjlhLWVhNDEtNGQyNS04OWIzLTdkMjA2NTM0MzEwMCIsIm1vYmlsZSI6Ijc4OTQ1NjEyMzMiLCJpc0FjdGl2ZSI6dHJ1ZSwicm9sZV9pZCI6IjM5MyIsImlhdCI6MTc5MDAxMTc1OCwiZXhwIjoxOTQ3NjkxNzU4fQ.-fkfvt2yDsdQtLjKEHw0qYGTVx6XTsYx_daW9ocdHUI'; // Token from back end to use invoice and add services
export const fetcherWithToken = axios.create({
  baseURL: REST_API,
  timeout: 13000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

// export const updateFetcher = (isGuestUser) => {
//   // eslint-disable-next-line no-unused-expressions
//   const token =
//     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwNSIsIm1vYmlsZSI6Ijk3OTE0MjY2ODEiLCJpc0FjdGl2ZSI6dHJ1ZSwiaWF0IjoxNjYwMTM2MDgxLCJleHAiOjE2NjA3NDA4ODF9.Bh_KrcRhb5Ku9RSvJ9nCo6zCLTAX5ibxO-a59hNDL0g';

//   fetcher.defaults.headers.common.android_id = token;
// };

export const sendRequest = (url, method, body) =>
  fetcher({
    method,
    url,
    data: body,
  }).then((res) => res.data);

export const sendRequestWithToken = (url, method, body) =>
  fetcherWithToken({
    method,
    url,
    data: body,
  }).then((res) => res.data);
